import { useEffect, useState } from 'react';

/**
 * Tailwind's md breakpoint: below 768px the room switches to the mobile layout (compact top
 * bar, fixed bottom control pill, full-screen side-panel overlay).
 */
export const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

/**
 * Tracks the viewport against the mobile breakpoint through matchMedia, so the room can switch
 * structure (not just classes) between the mobile and desktop layouts. jsdom answers false by
 * default; tests mock window.matchMedia to force either path.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    (): boolean => window.matchMedia(MOBILE_MEDIA_QUERY).matches,
  );

  useEffect(() => {
    const query = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (event: MediaQueryListEvent): void => {
      setIsMobile(event.matches);
    };
    query.addEventListener('change', onChange);
    return () => {
      query.removeEventListener('change', onChange);
    };
  }, []);

  return isMobile;
}
